import { useField } from 'formik';
import { forwardRef } from 'react';
import { FieldError } from '@/components/uielements/forms/field-error';
import {
  Input as NativeInput,
  type Props as NativeInputProps,
} from '@/components/uielements/forms/input';

interface Props extends NativeInputProps {
  name: string;
  validate?: (value: string) => string | undefined;
  normalize?: (value: string) => string;
  showErrorOnChange?: boolean;
}

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { normalize, validate, showErrorOnChange, ...restProps } = props;
  const [field, { error, touched }, { setValue }] = useField({ ...restProps, validate });
  const isCheckbox = restProps.type === 'checkbox';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isCheckbox) {
      field.onChange(event);
      return;
    }
    const rawValue = event.target.value;
    const normalizedValue = normalize ? normalize(rawValue) : rawValue;
    void setValue(normalizedValue);

    if (props.onChange) {
      const syntheticEvent = {
        ...event,
        target: { ...event.target, value: normalizedValue },
      };
      props.onChange(syntheticEvent);
    }
  };

  return (
    <>
      <NativeInput ref={ref} {...field} {...restProps} onChange={handleChange} />
      {(touched || showErrorOnChange) && error && <FieldError>{error}</FieldError>}
    </>
  );
});

Input.displayName = 'FormikInput';
